import { coreService } from 'Src/network/AutomatedService';

const service = {
  triggerPWReset: coreService['GET:PasswordEmail'],
};

type ForgotPasswordService = typeof service;

export default service;
export type { ForgotPasswordService };
